import { FullScreenAction } from "redux/actions/fullScreenAction";

export interface FullScreenState {
    open: boolean;
}

const initialState: FullScreenState = {
    open: false,
};

const fullScreenReducer = (state: FullScreenState = initialState, action: FullScreenAction) => {
    // console.log("action: ", action);
    // console.log("state: ", state);
    switch (action.type) {
        case "TURN_ON":
            return { ...state, open: true };
        case "TURN_OFF":
            return { ...state, open: false };
        default:
            return state;
    }
};

export default fullScreenReducer;
